var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9777 18.7891V9.75506C19.9777 9.16864 19.7338 8.6197 19.2801 8.24807C18.0881 7.27147 15.6625 5.33043 13.7323 3.60514C12.8709 2.83515 11.5615 2.7865 10.6842 3.53842L5.27214 8.17736C4.78206 8.59743 4.5 9.21068 4.5 9.85615V18.7891C4.5 20.0103 5.48994 21.0002 6.7111 21.0002H7.26387C8.48503 21.0002 9.47497 20.0103 9.47497 18.7891V16.578C9.47497 15.3569 10.4649 14.3669 11.6861 14.3669H12.7916C14.0128 14.3669 15.0027 15.3569 15.0027 16.578V18.7891C15.0027 20.0103 15.9926 21.0002 17.2138 21.0002H17.7666C18.9878 21.0002 19.9777 20.0103 19.9777 18.7891Z",
    stroke: "#838383",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome1);
export default __webpack_public_path__ + "static/media/home-1.b01a5b0799dd6db7dd54c53ffde8a657.svg";
export { ForwardRef as ReactComponent };